import { endpoint } from "service/endpoint";
import textLiterals from "assets/data/variants_dashboard_textLiterals.json";
const Axios = require("axios");

export async function getTextLiteral() {
  return process.env.NODE_ENV === "production"
    ? Axios.get(endpoint.concat("variants_dashboard_textLiterals.json"))
        .then((result) => {
          return result.data;
        })
        .catch((err) => {
          console.log("err :>> ", err);
          return {};
        })
    : new Promise((res, rej) => res(textLiterals));
}


export function getTopDisclaimer(textLiterals) {
  return textLiterals.topDisclaimer;
}

export function getAutoRefreshInterval(textLiterals){
  return textLiterals.autoRefreshInterval;
}

export function getVOCVOIProgressionChartTitle(textLiterals){
  return textLiterals.VOCVOIProgressionChartTitle;
}

export function getVOCVOIProgressionChartAxisLabels(textLiterals){
  return [textLiterals.VOCVOIProgressionChartXAxis ?? "", textLiterals.VOCVOIProgressionChartYAxis ?? ""];
}

export function getVariantsColorsMap(textLiterals){
  return textLiterals.VariantsColorsMap;
}